import { Box, Button, Divider, Text } from '@dixa/lib-shared-habla';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/generalSettings/languageSettings/languages';

import { ElevioIntegrationState } from '../../../../../../messengerSettings.types';

import {
  ElevioStateDescription,
  MessengerElevioSettings,
  MessengerElevioSettingsCallbacks,
} from './components';

type Props = {
  /** Elevio integration various states */
  state: ElevioIntegrationState;
  /** Set which language is being translated */
  selectedLanguage: MessengerTranslatedLanguage;
  /** Enable / disable elevio integration */
  onToggleElevioIntegration: () => void;
  /** Add / edit elevio account id */
  onEditElevioAccountId: () => void;
} & MessengerElevioSettingsCallbacks;

/**
 * Elevio integration component used to configure Elevio integration with the
 * messenger
 */
export function ElevioIntegration({
  state,
  onToggleElevioIntegration,
  onEditElevioAccountId,
  ...rest
}: Props): JSX.Element {
  return (
    <div>
      <Box margin="0 0 300 0">
        <Text.Heading variant="heading-2">Elevio integration</Text.Heading>
      </Box>
      <ElevioStateDescription
        state={state}
        onToggle={onToggleElevioIntegration}
      />

      {state.type === 'connected' && state.enabled && (
        <MessengerElevioSettings state={state} {...rest} />
      )}

      <Box margin="400 0">
        <Divider />
      </Box>

      <Button variant="secondary" type="button" onClick={onEditElevioAccountId}>
        {state.type === 'not-connected'
          ? 'Connect Elevio'
          : 'Edit Elevio account ID'}
      </Button>
    </div>
  );
}
